import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/commons/global.ts' );

const Cesium = (<any>window).Cesium;
export const PUBLIC_FOLDER_CHECK = "public_folder_check"

// configuration for the UI state machine
export const UiStateMachineConfig = Object.freeze({
    widgets: [
      { id: 'project_choices', },
      { id: 'scene_choices' },
      { id: 'main_tab' },
      { id: 'tools_menu' },
      { id: 'details' },
      { id: 'annotation' },
      { id: 'photos_window' },
      { id: 'layer' },
      { id: 'layer-photos' },
    ]
  });

export const AnnotationType = Object.freeze({

    // handles and ghosts
    handle: 'handle',
    addhandle: 'addhandle',
    deletehandle: 'deletehandle',
    ghostline: 'ghostline',
    ghostlineLabel: 'ghostlinelabel',
    volumepoint: 'volumepoint',
    edgeinfo: 'edgeinfo',

    // types
    poi: 'poi',
    area: 'area',
    line: 'line',
    volume: 'volume',
    multipoi: 'multiPoi',

    // else
    other: 'other'

});

export const AnnotationStyle = Object.freeze({

    dotSize: 6,
    dotColor: Cesium.Color.RED.withAlpha(0.8),
    dotOutlineColor: Cesium.Color.YELLOW,
    dotOutlineSize: 0,

    dotNormalSize: 11,
    dotNormalColor: Cesium.Color.YELLOW ,
    dotNormalOutlineColor: Cesium.Color.BLACK.withAlpha(0.7),
    dotNormalOutlineSize: 3,

    dotSelectedSize: 11,
    dotSelectedColor: Cesium.Color.RED,
    dotSelectedOutlineColor: Cesium.Color.YELLOW,
    dotSelectedOutlineSize: 3,

    locationSize: 30,
    locationColor: Cesium.Color.BLUE.withAlpha(0.8),
    locationOutlineSize: 1,
    locationOutlineColor: Cesium.Color.WHITE

});

export const AppConstants = Object.freeze({
    STATUS_SCHEDULED        : 1,
    STATUS_PROGRESS         : 2,
    STATUS_FINISHED         : 3,
    SCREEN_MOBILE           : 768,
    DATAUM_ASSET         : "datumAsset"
});

export const Notification = Object.freeze({
    INFO       : "info-dialog",
    WARN       : "warning-dialog",
    ERROR      : "error-dialog",
    SUCCESS    : "success-dialog"
});

export const APITypes = {
    ProcessorAPI: {NAME:"ProcessorAPI",IMPL:"lib.processors.Remote4DProcessor"},
    Datum360: {NAME:"Datum360",IMPL:"lib.processors.remote_apis.Datum360"},
    AutoDesk: {NAME:"AutoDesk",IMPL:"lib.workers.AutodeskWorker"},
    Trackonus: {NAME:"Trackonus",IMPL:"lib.processors.Remote4DProcessor"},
    Photoscan: {NAME:"Photoscan",IMPL:"Photoscan"},
    Agronomeye: {NAME:"Agronomeye",IMPL:"lib.processors.remote_apis.Agronomeye"},
    PositionPartners: {NAME:"PositionPartners",IMPL:"lib.processors.remote_apis.PositionPartners"},
    CapturingReality: {NAME:"CapturingReality",IMPL:"Photoscan"},
    SDK: {NAME:"SDK",IMPL:"SDK"}

}

export class AppRoutes {
    // AuthModule
    static AUTH             = "auth"
    static EMAIL            = "email"
    static SIGNUP           = "signup"
    static ACTIVATE_ACC     = "activate/:account/:token"
    static ACTIVATE_ACC_GRP = "activate/:account/:groupUID/:token"
    static ACTIVATE_NO_ACC  = "activate/:token"
    static OAUTH_PATH       = "oauth"
    static OAUTH            = AppRoutes.OAUTH_PATH + "/:client"
    static MSG              = "msg/:message"
    static AUTH_EMAIL       = AppRoutes.AUTH + "/" + AppRoutes.EMAIL
    static AUTH_SIGNUP      = AppRoutes.AUTH + "/" + AppRoutes.SIGNUP
    static AUTH_OAUTH       = AppRoutes.AUTH + "/" + AppRoutes.OAUTH_PATH
    // Main module
    static MAIN             = "app"
    static JOBS             = "jobs"
    static MAP              = "map"
    static EXPLORER         = "explorer"
    static PROJECTS         = "projects"
    static INSPECTOR        = "inspector"
    static PROFILE          = "profile"
    static CONTACT          = "contact"
    static ADMIN            = "admin"
    static ACCOUNT          = "account"
    static USERS            = "users"
    static APIS             = "apis"
    static INIT             = "init"
    static MAIN_EXPLORER    = AppRoutes.MAIN + "/" + AppRoutes.EXPLORER
    static MAIN_INSPECTOR   = AppRoutes.MAIN + "/" + AppRoutes.INSPECTOR
    static MAIN_PROFILE     = AppRoutes.MAIN + "/" + AppRoutes.PROFILE
    static MAIN_CONTACT     = AppRoutes.MAIN + "/" + AppRoutes.CONTACT
    static MAIN_SETTINGS    = AppRoutes.MAIN + "/" + AppRoutes.ADMIN
    static MAIN_PROJECTS    = AppRoutes.MAIN + "/" + AppRoutes.PROJECTS
    static ADMIN_ACCOUNT    = AppRoutes.ADMIN + "/" + AppRoutes.ACCOUNT
    static ADMIN_USERS      = AppRoutes.ADMIN + "/" + AppRoutes.USERS
    static ADMIN_APIS       = AppRoutes.ADMIN + "/" + AppRoutes.APIS
}